import { Component, OnInit } from '@angular/core';
import { Client } from '@core/model/client.model';
import { FormBuilder, Validators } from '@angular/forms';
import { ClientService } from '@core/service/client.service';
import Swal from 'sweetalert2';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CreateClientComponent } from '@app/dashboard/client/create-cliente/create-cliente.component';
import { Paginated } from '@app/core/model/paginated.model';
import { Subject } from 'rxjs';
import { environment } from '@env/environment.prod';
import { UserService } from '@app/core';
import { User } from '@app/core/model/user.model';

@Component({
  selector: 'app-cliente-list',
  templateUrl: './cliente-list.component.html',
  styleUrls: ['./cliente-list.component.css']
})
export class ClienteListComponent implements OnInit {
  clients: Client[];
  modalOptions: NgbModalOptions = {};
  imageURL = environment.imgUrl;

  pager = {};
  pageOfItems: any = [];
  users: User[];
  clientes: Paginated;
  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;

  vendededor_id:number=0;

  paginanum:number;

  constructor(
    private formBuilder: FormBuilder,
    public clientService: ClientService,
    private userService: UserService,
    private modalService: NgbModal
  ) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    };
  }

  ngOnInit() {
    // this.createForm();
    // this.listClient();
    this.listVendedores();

    this.clientService
      .getClientes(" ", this.vendededor_id)
      .then(clientes => (this.clientes = clientes));

    this.searchTermStream.subscribe((term: string) => {
      this.clientService.search(term, this.vendededor_id).then((clientes: any) => {
        this.currentSearchTerm = term;
        this.updateClientes(clientes);
      });
    });
  }

  listVendedores() {
    this.userService.getAllVendedores().subscribe(
      data => {
        this.users = data;
        console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  updateClientes(clientes: Paginated) {
    const clientesWithUpdatedNavs = this.updateNavUrls(
      this.currentSearchTerm,
      clientes
    );
    this.clientes = clientesWithUpdatedNavs;
  }
  updateNavUrls(term: string, clientes: Paginated): Paginated {
    if (term) {
      if (clientes.prev_page_url) {
        clientes.prev_page_url += `&term=${term}`;
      }
      if (clientes.next_page_url) {
        clientes.next_page_url += `&term=${term}`;
      }
    }
    return clientes;
  }

  prevPage() {
    this.clientService
      .getClientesAtUrl(this.clientes.prev_page_url)
      .then((clientes: any) => {
        this.updateClientes(clientes);
      });
  }

  nextPage() {
    this.clientService
      .getClientesAtUrl(this.clientes.next_page_url)
      .then((clientes: any) => {
        this.updateClientes(clientes);
      });
  }

  onChange(event:number) {

    this.vendededor_id = event;

   
    this.clientService
    .getClientes(" ", this.vendededor_id)
    .then(clientes => (this.clientes = clientes));

  this.searchTermStream.subscribe((term: string) => {
    
    this.clientService.search(term, this.vendededor_id).then((clientes: any) => {
      this.currentSearchTerm = term;
      this.updateClientes(clientes);
    });
  });

}
crearPDF()
  {
    //console.log(this.Array);

    this.clientService.verPDF().subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob = new Blob([x], { type: 'application/pdf' });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
     

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var date = new Date();
      const link = document.createElement('a');
      link.href = data;
      link.download = "visita_" + date+ '.pdf';
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );

      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });


  }

  search(term: string) {
    this.searchTermStream.next(term);
  }

  searchPage(value:number)
  {
    this.clientService
    .getClientesAtUrl2(value)
      .then((clientes: any) => {
        this.updateClientes(clientes);
      });

  }

  /*  createForm() {
      this.clientForm = this.formBuilder.group({
        nombres: ['', [Validators.required]],
        apellidos: ['', [Validators.required]],
        ci_nit: ['', [Validators.required]],
        direccion: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        // latitud: ['', [Validators.required]],
        // longitud: ['', [Validators.required]],
        foto: ['', [Validators.required]],
        celular: ['', [Validators.required]]
      });
    }*/
  listClient() {
    this.clientService.getAll().subscribe(
      data => {
        this.clients = data;
      },
      error => {
        console.log(error.error);
      }
    );
  }

  /*registerClient() {
    const newClient: Client = new Client();
    newClient.nombres = this.clientForm.value.nombres;
    newClient.apellidos = this.clientForm.value.apellidos;
    newClient.ci_nit = this.clientForm.value.ci_nit;
    newClient.direccion = this.clientForm.value.direccion;
    newClient.email = this.clientForm.value.email;
    newClient.foto = this.clientForm.value.foto;
    newClient.celular = this.clientForm.value.celular;
    // newClient.latitud=this.clientForm.value.latitud;
    // newClient.longitud=this.clientForm.value.longitud;
    newClient.email = this.clientForm.value.email;

    this.clientService.create(newClient).subscribe(
      data => {
        Swal.fire(data);
        this.clientForm.reset();
        this.listClient();
      },
      error => {
        Swal.fire(error.error);
      }
    );
  }*/

  /* enableClient(id: number) {
    this.clientService.enableClient(id).subscribe(
      data => {
        this.listClient();
      },
      error => {
        console.log(error.error);
      }
    );
  }*/
  createClient() {
    const modalRef = this.modalService.open(
      CreateClientComponent,
      this.modalOptions
    );
    modalRef.componentInstance.title = 'Crear nuevo cliente';
    modalRef.result.then(result => {
      if (result) {
        this.clientService
          .getClientes(" ", this.vendededor_id)
          .then(clientes => (this.clientes = clientes));
        this.searchTermStream.subscribe((term: string) => {
          this.clientService.search(term, this.vendededor_id).then((clientes: any) => {
            this.currentSearchTerm = term;

            this.updateClientes(clientes);
          });
        });
      }
    });
  }
  eliminar(id: string) {
    Swal.fire({
      title: 'Esta seguro de Eliminar el cliente?',
      text: 'Una vez eliminado, Ud no podra recuperar el cliente eliminado!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then(willDelete => {
      if (willDelete.value) {

        this.clientService.delete(id).subscribe(x => {
          this.listClient();
        });
        Swal.fire('Se elimino correctamente');



      } else {
        Swal.fire('No se pudo eliminar');
      }

      console.log(willDelete);
    });
  }

  editModal(id: string) {
    // alert(id);
    const modal = this.modalService.open(
      CreateClientComponent,
      this.modalOptions
    );
    modal.componentInstance.cliente_id = id;
    modal.componentInstance.estado = true;
    modal.componentInstance.title = 'Editar Cliente';
    modal.result.then(result => {
      if (result) {
        this.clientService
          .getClientes(" ", this.vendededor_id)
          .then(clientes => (this.clientes = clientes));
        this.searchTermStream.subscribe((term: string) => {
          this.clientService.search(term, this.vendededor_id).then((clientes: any) => {
            this.currentSearchTerm = term;
            this.updateClientes(clientes);
          });
        });
      }
    });

    // modal.close();
  }
}
